// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34xXT","comment":"styles_comment__1HSP4"};